import React, { useEffect, useState } from "react";
import {
    Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem,
    Button, Paper, Divider, Stack, Card, CardContent, alpha
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CallIcon from "@mui/icons-material/Call";
import PaymentsIcon from "@mui/icons-material/Payments";

import {
    collection,
    getDocs
} from "firebase/firestore";

import { db } from "../../firebase";

function Salaryslip() {

    const [loading, setLoading] = useState(false);

    const [staffList, setStaffList] = useState([]);
    const [attendance, setAttendance] = useState([]);
    const [advances, setAdvances] = useState([]);

    const [selectedStaff, setSelectedStaff] = useState("");
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const [salaryData, setSalaryData] = useState(null);

    const months = [
        "January", "February", "March", "April",
        "May", "June", "July", "August",
        "September", "October", "November", "December"
    ];

    const years = [2024, 2025, 2026, 2027];

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {

        try {

            setLoading(true);

            const [staffSnap, attendanceSnap, advanceSnap] = await Promise.all([
                getDocs(collection(db, "staff")),
                getDocs(collection(db, "staffattendance")),
                getDocs(collection(db, "staffadvances"))
            ]);

            setStaffList(
                staffSnap.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
            );

            setAttendance(
                attendanceSnap.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
            );

            setAdvances(
                advanceSnap.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
            );

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const generateSalarySlip = () => {

        if (!selectedStaff) {
            alert("Please Select Staff");
            return;
        }

        const staff = staffList.find(s => s.id === selectedStaff);

        if (!staff) {
            alert("Staff not found");
            return;
        }

        let present = 0;
        let absent = 0;
        let halfday = 0;

        attendance.forEach((att) => {

            if (att.staffId !== selectedStaff) return;

            const attDate = new Date(att.date);

            const month = attDate.getMonth() + 1;
            const year = attDate.getFullYear();

            if (
                Number(month) === Number(selectedMonth) &&
                Number(year) === Number(selectedYear)
            ) {

                if (att.status === "Present") {
                    present++;
                }

                else if (att.status === "Absent") {
                    absent++;
                }

                else if (att.status === "Half Day") {
                    halfday++;
                }
            }
        });

        const monthlySalary = Number(staff.payment || 0);

        const perDaySalary = monthlySalary / 30;

        const earnedSalary =
            (present * perDaySalary) +
            (halfday * perDaySalary * 0.5);

        const pendingAdvance = advances
            .filter(
                adv =>
                    adv.staffId === selectedStaff &&
                    adv.status === "Pending"
            )
            .reduce((sum, adv) => sum + Number(adv.payment || 0), 0);

        const netSalary = earnedSalary - pendingAdvance;

        setSalaryData({
            staff,
            present,
            absent,
            halfday,
            monthlySalary,
            perDaySalary,
            earnedSalary,
            pendingAdvance,
            netSalary
        });
    };

    const handlePrint = () => {
        window.print();
    };

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="80vh"
            >
            </Box>
        );
    }

    return (
        <Box sx={{ p: { xs: 2, md: 1 }, bgcolor: "#f0f2f5", minHeight: "100vh" }}>

            {/* FILTER SECTION */}
            <Paper sx={{ p: 1, borderRadius: 4, mb: 4, boxShadow: "0px 4px 20px rgba(0,0,0,0.05)" }}>
                <Typography variant="h6" fontWeight="700" mb={3} display="flex" alignItems="center" gap={1}>
                    <ReceiptLongIcon color="primary" /> Generate Salary Slip
                </Typography>

                <Grid className="row" spacing={3} alignItems="center">
                    <Grid className="col-sm-3 mb-3" item xs={12} md={4}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel>Staff Member</InputLabel>
                            <Select size="small" value={selectedStaff} label="Staff Member" onChange={(e) => setSelectedStaff(e.target.value)}>
                                {staffList.map((staff) => (
                                    <MenuItem key={staff.id} value={staff.id}>{staff.name} ({staff.post})</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid className="col-sm-3 mb-3" item xs={6} md={2}>
                        <FormControl fullWidth>
                            <InputLabel>Month</InputLabel>
                            <Select size="small" value={selectedMonth} label="Month" onChange={(e) => setSelectedMonth(e.target.value)}>
                                {months.map((month, index) => <MenuItem key={index} value={index + 1}>{month}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid className="col-sm-3 mb-3" item xs={6} md={2}>
                        <FormControl fullWidth>
                            <InputLabel>Year</InputLabel>
                            <Select size="small" value={selectedYear} label="Year" onChange={(e) => setSelectedYear(e.target.value)}>
                                {years.map((year) => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid className="col-sm-3 mb-3" item xs={12} md={4}>
                        <Button variant="contained" size="large" fullWidth sx={{ height: 56, borderRadius: 2, fontWeight: 'bold' }} onClick={generateSalarySlip}>
                            Generate Slip
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {/* SALARY SLIP DOCUMENT */}
            {salaryData && (
                <Paper
                    id="salary-slip"
                    className="printable-area"
                    sx={{
                        p: 3,
                        borderRadius: 3,
                        maxWidth: 1100,
                        margin: "auto",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                        bgcolor: "#fff",
                        border: "1px solid #e0e0e0"
                    }}
                >
                    {/* HEADER */}
                    <Box textAlign="center" mb={3}>
                        <Typography variant="h5" fontWeight="bold">Vishwajeet Khadi Kendra</Typography>
                        <Typography variant="body2">Dharashiv, Maharashtra</Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Salary Slip | {months[selectedMonth - 1]} {selectedYear}
                        </Typography>
                    </Box>

                    {/* EMPLOYEE INFO - Compact Grid */}
                    <Box sx={{ bgcolor: "#f9f9f9", p: 2, borderRadius: 2, mb: 3 }}>
                        <Grid className="row" spacing={1}>
                            {[
                                { label: "Staff Name", val: salaryData.staff.name },
                                { label: "Post", val: salaryData.staff.post },
                                { label: "Mob", val: salaryData.staff.mobile || "-" },
                                { label: "Gross", val: `₹${salaryData.monthlySalary.toFixed(0)}` },
                            ].map((item, i) => (
                                <Grid className="col-sm-3 mb-3" item xs={6} key={i}>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                        {item.label}
                                    </Typography>
                                    <Typography variant="body2" fontWeight="600" sx={{ fontSize: '0.85rem' }}>
                                        {item.val}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* ATTENDANCE SUMMARY - Tiny Boxes */}
                    <Box display="flex" gap={1} mb={3}>
                        {[
                            { label: "Pres", val: salaryData.present, color: "#2e7d32" },
                            { label: "Half", val: salaryData.halfday, color: "#ed6c02" },
                            { label: "Abs", val: salaryData.absent, color: "#d32f2f" }
                        ].map((stat, i) => (
                            <Box key={i} sx={{ flex: 1, textAlign: 'center', p: 1, borderRadius: 2, border: `1px solid ${alpha(stat.color, 0.2)}`, bgcolor: alpha(stat.color, 0.05) }}>
                                <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 'bold', display: 'block' }}>{stat.label}</Typography>
                                <Typography variant="subtitle2" fontWeight="800" color={stat.color}>{stat.val}</Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* CALCULATION */}
                    <Stack spacing={0.5} sx={{ mb: 3 }}>
                        {[
                            { label: "Monthly Base", val: salaryData.monthlySalary },
                            { label: `Days (${salaryData.present})`, val: salaryData.present * salaryData.perDaySalary },
                            { label: `Half (${salaryData.halfday})`, val: salaryData.halfday * salaryData.perDaySalary * 0.5 },
                            { label: "Advance", val: salaryData.pendingAdvance, isDeduction: true }
                        ].map((row, i) => (
                            <Box key={i} display="flex" justifyContent="space-between" sx={{ fontSize: '0.85rem' }}>
                                <Typography color="text.secondary">{row.label}</Typography>
                                <Typography fontWeight="600" color={row.isDeduction ? "error" : "text.primary"}>
                                    {row.isDeduction ? "-" : ""}₹{row.val.toFixed(0)}
                                </Typography>
                            </Box>
                        ))}

                        <Box display="flex" justifyContent="space-between" mt={1} pt={1} sx={{ borderTop: "2px dashed #e0e0e0" }}>
                            <Typography variant="subtitle2" fontWeight="800" color="primary">Net Payable</Typography>
                            <Typography variant="subtitle2" fontWeight="800" color="primary">₹{salaryData.netSalary.toFixed(0)}</Typography>
                        </Box>
                    </Stack>

                    {/* FOOTER */}
                    <Box display="flex" justifyContent="space-between" mt={4}>
                        <Typography variant="caption" sx={{ pt: 1, borderTop: "1px solid #ccc", fontSize: '0.7rem' }}>Emp. Sign</Typography>
                        <Typography variant="caption" sx={{ pt: 1, borderTop: "1px solid #ccc", fontSize: '0.7rem' }}>Auth. Sign</Typography>
                    </Box>

                    {/* PRINT BUTTON */}
                    <Box textAlign="center" mt={3} className="no-print">
                        <Button variant="contained" size="small" startIcon={<PrintIcon />} onClick={handlePrint} sx={{ borderRadius: 2, px: 3 }}>
                            Print
                        </Button>
                    </Box>
                </Paper>
            )}

            <style>{`
    @media print {
      body * { visibility: hidden; }
      .printable-area, .printable-area * { visibility: visible; }
      .printable-area { position: absolute; left: 0; top: 0; width: 100%; }
      .no-print { display: none !important; }
      @page { size: A4; margin: 15mm; }
    }
  `}</style>
        </Box>
    );
}

export default Salaryslip;